<div class="confirm-btns">
  <img
    [src]="'../../assets/images/check_circle.svg'"
    class="conf-image check-image"
    (click)="delete(true)"
  />
  <img
    [src]="'../../assets/images/cancel_circle_gray.svg'"
    class="conf-image"
    (click)="delete(false)"
  />
</div>
